module.exports = __webpack_public_path__ + "20b644ff88a986ba50d23a1dfa9d230e.png";